import React, { Component } from 'react'
import { Grid, Cell } from 'styled-css-grid'
import { inject, observer } from 'mobx-react'
import cn from 'classnames'
import Loader from '@ui/Loader'
import Footer from '../Footer'
import Topnav from '../Pieces/Topnav'
import Main from '../Pieces/Main'

@inject('surveyState')
@observer
export default class Layout extends Component {
  static Main = Main
  static Topnav = Topnav

  componentDidMount() {
    if (this.props.surveyState.hasBrandColor) this.getCustomization()
  }

  renderComponent = name =>
    React.Children.toArray(this.props.children).find(
      child => child.type.displayName === name
    ) || null

  getCustomization() {
    const { surveyState } = this.props

    const root = document.documentElement
    root.style.setProperty('--color1', surveyState.customization.brand_color)
    root.style.setProperty('--button-bg', '110, 111, 128')
    root.style.setProperty('--button-border', '110, 111, 128')
    root.style.setProperty('--button-color', '110, 111, 128')
  }

  render() {
    const { brandLogo, className = '', all, retrieving } = this.props

    return retrieving ? (
      <Loader />
    ) : (
      <Grid
        columns='1fr'
        rows='max-content 1fr max-content'
        areas={['topnav', 'main', 'footer']}
        columnGap='0'
        rowGap='0'
        className={cn(`survey-layout ${className}`, { all })}
      >
        <Cell area='topnav'>{this.renderComponent('Topnav')}</Cell>
        <Cell area='main' className='main flex full height'>
          {this.renderComponent('Main')}
        </Cell>
        <Cell area='footer'>
          <Footer showCrosschqLogo={brandLogo} />
        </Cell>
      </Grid>
    )
  }
}
